import { render } from "./lotsTabsAddress.vue?vue&type=template&id=70b1fce4"
import script from "./lotsTabsAddress.vue?vue&type=script&lang=js"
export * from "./lotsTabsAddress.vue?vue&type=script&lang=js"

import "./lotsTabsAddress.vue?vue&type=style&index=0&id=70b1fce4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__